module.exports = __webpack_public_path__ + "static/media/cc_amex.f696c930.png";